import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DynamicConditionalActionChainArgs } from './dynamic-conditional-action-chain-args';

export interface Step {
  stepType: string;
}

export type StepNextType =
  | Action
  | Action[]
  | DynamicConditionalActionChainArgs;

export interface SelectNextByValueStep<Y> extends Step {
  stepType: 'SelectNextByValueStep';
  value: Observable<Y>;
  nextSelector: { matcher: (value: Y) => boolean; nextStep: StepNextType }[];
}

export interface SelectNextByActionStep extends Step {
  stepType: 'SelectNextByActionStep';
  next: { nextStep: StepNextType; matcher: (action: Action) => boolean }[];
  dispatch?: Action | Action[];
}

export function isStep(
  value: unknown,
): value is SelectNextByValueStep<unknown> | SelectNextByActionStep {
  const key: keyof Step = 'stepType';
  return (
    value !== undefined &&
    value !== null &&
    typeof value === 'object' &&
    key in value
  );
}
